import {
  useMaterialStorageDataQuery,
  useStoredMaterialIdsFromHistoryQuery
} from '@domain/material-storage'
import {useStockDevelopmentQuery} from '@domain/schedule'
import {useUpmPlantTimezone} from '@hconnect/upm'
import {useTheme} from '@mui/material'
import {getListOfDays, usePlanningChartStartEnd} from '@widgets/planning-schedule-chart'
import {StockDevelopmentChartSkeleton} from '@widgets/stock-card'

import {PlanningStockDevelopmentChart} from './PlanningStockDevelopmentChart'

interface PlanningStockDevelopmentChartContainerProps {
  materialId: number
}

export const PlanningStockDevelopmentChartContainer = ({
  materialId
}: PlanningStockDevelopmentChartContainerProps) => {
  const {spacing} = useTheme()
  const timezoneId = useUpmPlantTimezone()
  const {startOfPlan, endOfPlan, startOfChart, endOfChart} = usePlanningChartStartEnd()

  const {data: allMaterialIds} = useStoredMaterialIdsFromHistoryQuery({
    timeFrame: [startOfPlan, endOfPlan]
  })

  const {data: stockDevelopment, isLoading: isStockDevelopmentLoading} = useStockDevelopmentQuery({
    materialIds: allMaterialIds,
    timeframe: [startOfPlan, endOfPlan]
  })
  const {data: storageData} = useMaterialStorageDataQuery({materialId})

  const listOfDays = getListOfDays({start: startOfChart, end: endOfChart, additionalDays: 1})

  const shouldShowChartSkeleton = !listOfDays || isStockDevelopmentLoading || !stockDevelopment

  const chartHeight = spacing(50)

  return shouldShowChartSkeleton ? (
    <StockDevelopmentChartSkeleton height={chartHeight} />
  ) : (
    <PlanningStockDevelopmentChart
      timezoneId={timezoneId}
      listOfDays={listOfDays}
      stockData={stockDevelopment[materialId]}
      minTargetLevels={
        storageData && {
          week: storageData.minTargetLevel,
          weekend: storageData.minTargetLevelWeekend
        }
      }
      deadStockLevel={storageData?.deadStockLevel}
      storageCapacity={storageData?.storageCapacity}
      height={parseInt(chartHeight)}
    />
  )
}
